import * as React from 'react';
import * as service from 'service';
import * as utils from 'utils';
import * as DateFns from 'date-fns';
import { Button, Paging } from 'arbina-ui';
import { PackTable } from './components/PackTable';
import { EditDialog } from './components/EditDialog';
import { Pack } from 'types';
import { Loader } from 'components';
import * as style from './style.sass';

interface State {
  itemBeingEdited?: Pack | null;
  packs: {
    items: Pack[];
    total: number;
  };
  filter: {
    offset: number;
    limit: number;
  };
  processing: boolean;
}

export class PacksList extends React.Component {
  state: State = {
    itemBeingEdited: null,
    packs: {
      items: [],
      total: 0,
    },
    filter: {
      offset: 0,
      limit: 20,
    },
    processing: false,
  };

  async componentDidMount() {
    const { filter } = this.state;
    await this.fetchPacksList(filter.offset, filter.limit);
  }

  fetchPacksList = async (offset: number, limit: number) => {
    this.setState({ processing: true });
    const response = await service.getPackList(offset, limit);
    this.setState({
      filter: {
        ...this.state.filter,
        offset,
      },
      packs: response.data,
      processing: false,
    });
  }

  onAddPack = () => this.setState({
    itemBeingEdited: {
      id: '',
      items: [],
      properties: [],
      publishAt: DateFns.startOfToday(),
    },
  })

  onEditPack = (pack: Pack) => this.setState({ itemBeingEdited: pack });

  closeDialog = () => this.setState({ itemBeingEdited: null });

  onPackSubmit = async (notify: Function, pack: Pack) => {
    const { filter } = this.state;

    try {
      this.setState({ processing: true });
      await service.savePack(pack);
      await this.fetchPacksList(filter.offset, filter.limit);
      this.closeDialog();
    } catch (error) {
      notify({
        title: `Cannot ${pack.id ? 'update' : 'create'} pack`,
        message: error.response.data.description,
        level: 'error',
      });
      throw error;
    } finally {
      this.setState({ processing: false });
    }
  }

  onDeletePack = async (pack: Pack) => {
    if (confirm('Delete chosen pack?')) {
      this.setState({ processing: true });
      await service.deletePack(pack.id);
      await this.fetchPacksList(0, 20);
    }
  }

  onPageChange = async (offset: number) => {
    const { filter } = this.state;
    await this.fetchPacksList(offset, filter.limit);
  }

  render() {
    const { itemBeingEdited, packs, processing, filter } = this.state;
    return (<utils.CONTEXT.Consumer>
      {(context: any) => {
        return (<div>
          {processing && <Loader overlay/>}
          <div className={style.toolbar}>
            <Button
              autoFocus
              primary
              text="Add new pack"
              onClick={this.onAddPack}
            />
            <Paging
              offset={filter.offset}
              total={packs.total}
              pageSize={filter.limit}
              onClick={this.onPageChange}
            />
          </div>
          <PackTable
            items={packs.items}
            onStartEditItem={this.onEditPack}
            onDeleteItem={this.onDeletePack}
          />
          {!!itemBeingEdited && <EditDialog
            pack={itemBeingEdited}
            onClose={this.closeDialog}
            onSubmit={this.onPackSubmit.bind(this, context.notify)}
          />}
        </div>);
      }}
    </utils.CONTEXT.Consumer>);
  }
}
